var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"opacity":".8"}},[_c('v-sheet',{staticClass:"pa-5 text-center"},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_vm._v(" Esta função só pode ser acessada no modo ONLINE ")]),_c('v-col',[_c('v-btn',{attrs:{"color":"info","rounded":""},on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("OK")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }